var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 1.1662V12.8338M11.0837 4.4072L12.8338 9.5928C12.3289 10.0136 11.7148 10.241 11.0837 10.241C10.4525 10.241 9.83842 10.0136 9.33352 9.5928L11.0837 4.4072ZM11.0837 4.4072V3.759M1.74958 3.759H2.33296C3.96082 3.759 5.56365 3.31377 7 2.4626C8.43635 3.31377 10.0392 3.759 11.667 3.759H12.2504M2.91634 4.4072L4.66648 9.5928C4.16158 10.0136 3.54747 10.241 2.91634 10.241C2.28521 10.241 1.6711 10.0136 1.1662 9.5928L2.91634 4.4072ZM2.91634 4.4072V3.759M4.0831 12.8338H9.9169",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceNew);
export default __webpack_public_path__ + "static/media/InvoiceNew.caf437987536e3d17675e64f7aaca072.svg";
export { ForwardRef as ReactComponent };